import React from "react";
import { useState, useEffect } from "react";
import Header from "../Components/Header/Header";
import StatusCard from "../Components/Cards/StatusCard";
import RouteTable from "../Components/Tables/RouteTable";
import RouteMapView from "../Components/MapViews/RouteMapView";

import { db } from "../firebase";
import {equalTo, onValue, ref, set, query, orderByChild, orderByValue, get } from 'firebase/database';




export default AddRoute => {
    const [numBinsCount, setNumBinsDataCount] = useState({
        binsActive: 0, 
        binsFilled:0,
        binsInactive:0,
        noOfRoutes:0,
        activeCollectors: 0,
        totalCollectors: 0,
    });

    // const data = Data;

    
    const getBins = async () =>{
        const binRef = await ref(db, 'bins');
        onValue(binRef, (snapshot) => {
            const data = snapshot.val();
            // var activeBins = Object.keys(data).length
            var activeBins = Object.values(data).filter(bin => bin.status === 'active').length;
            var inactiveBins = Object.values(data).filter(bin => bin.status === 'Inactive').length;
            var filledBins = Object.values(data).filter(bin => bin.capacity >= 45).length;
            var closeToFillBins = Object.values(data).filter(bin => bin.capacity >= 70 && bin.capacity < 75).length;
            setNumBinsDataCount({
                binsActive: activeBins,
                binsFilled: filledBins,
                binsInactive: inactiveBins,
                binsCloseToFill: closeToFillBins,
            });
            // console.log(activeBins)
            // const filledBins = query(data, orderByChild('status'))
            console.log(closeToFillBins)
        })

    }

    const getRoutes = async () =>{
        const binRef = await ref(db, 'routes');
        onValue(binRef, (snapshot) => {
            const data = snapshot.val();
            var noOfRoutes = Object.keys(data).length
            console.log(noOfRoutes)
        
            setNumBinsDataCount((prev) => ({
                ...prev,
                noOfRoutes: noOfRoutes,
            }))
            
        })

    }


    const getCollectors = async () =>{
        const colRef = await ref(db, 'workers');
        onValue(colRef, (snapshot) => {
            const data = snapshot.val();
            // var activeBins = Object.keys(data).length
            var activeCols = Object.values(data).filter(worker => worker.status === 'active').length;
            var totalCols = Object.values(data).length;
            setNumBinsDataCount((prev) => ({
                ...prev,
                activeCollectors: activeCols,
                totalCollectors : totalCols,
                
            }));
            // console.log(activeBins)
            // const filledBins = query(data, orderByChild('status'))
            console.log('total Cols ===>', totalCols)
        })

    }
    
    // useEffect(()=>{
        // },[])
        
    useEffect(()=>{
        getBins();
        getCollectors();
        getRoutes();
    },[])
    


    return(
        <>
            <Header />
            <div className="max-w-screen-xl px-4 mx-auto">
                <div className="my-12">
                    {/* <a href="" className="text-white">Go back</a> */}
                </div>
                <div className="flex gap-x-5 boxes">
                    <div className="w-9/12 box-1">
                        <div className="flex items-center justify-between mb-4 binhead">
                            <h3 className="mb-2 text-4xl font-bold tracking-tight text-gray-900 dark:text-white">Add Routes</h3>
                        </div>

                        {/* Map View */}
                        <div className="bg-gray-800 h-auto relative pb-2.5 rounded-lg MapView">
                            {/* <h5 className="text-white text-xl px-2.5 py-2.5 font-bold">Map View</h5>
                            <div className="bg-gray-800" style={{height: '345px'}}> */}
                               
                                <RouteMapView />
     
                            {/* </div> */}
                        </div>
                    </div>
                            
                    <div className="w-4/12  box-2">
                        <div className="flex flex-col gap-y-5 ">
                            <StatusCard cardWidth={""} color="text-green-500" cardhead="Filled Bins" CardVal={numBinsCount.binsFilled} closeToFillShow={false} imgShow={true} imgImage={"https://drive.google.com/uc?export=view&id=1__h73dKYlAVSoaLhNPt3ZGdBlX1DI7BY"}/>
                            <StatusCard cardWidth={""} color="text-white" cardhead="Active Collectors" CardVal={numBinsCount.activeCollectors} closeToFillShow={true} imgShow={true} imgImage={"https://drive.google.com/uc?export=view&id=1P5EFS9UJLXe1O-0rA1zvH0TpxyvtXrXC"}/>
                            <StatusCard cardWidth={""} color="text-red-500" cardhead="Routes" CardVal={numBinsCount.noOfRoutes} closeToFillShow={false} imgShow={true} imgImage={"https://pngimg.com/d/recycle_bin_PNG45.png"}/>
                        </div>
                        {/* <div className="bg-gray-800 py-2.5 mt-5 rounded-lg Generated-Routes">
                            <AssignedCollectorTable />
                        </div> */}
                    </div>

                </div>
                    <div className="bg-gray-800 py-2.5 mt-5 rounded-lg overflow-hiddenGenerated-Routes">
                        <RouteTable />
                    </div>
            </div>
        </>
    )
}